export default __webpack_public_path__ + "static/portfolio-13-d4435b088183812740486087412e2aef.jpg";